import { useEffect, useRef, useState, useLocation } from '../../common/common';
import * as XLSX from 'xlsx';
import axiosJWT from '../../secureAPI/axiosJWT';
import { showToast } from '../../Utils/toastUtils';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { validateAddSubCategoryForm } from '../../validation/Authentication/Validation.js';
import { useErrorContext } from '../../context/ErrorContext';
import getUserData from '../../secureAPI/GetUserData';
import useNavigation from '../../common/useNavigation';
import useGetUserData from '../../secureAPI/GetUserData';
const MidViewProducts = () => {
    const isMounted = useRef(true);
    const location = useLocation();
    const { navigateMain } = useNavigation();
    const { users,userPlan,Remainuser,subUser } = useGetUserData();
    const { setValidationError, clearAllErrors } = useErrorContext();
    const [isDisabled, setisDisabled] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [seacrh, setSearch] = useState('');
    const [sheetdata, setSheetdata] = useState([]);
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [productID, setProductID] = useState(0);

    useEffect(() => {
        isMounted.current = true;
        getProducts();
        return () => {
            // Component unmount hone par flag false kar do
            isMounted.current = false;
        };
    }, []);
    useEffect(() => {
        //  console.log('called useeffectsss');
        if (Array.isArray(users) && users.length > 0) {
            // console.log('useEffect called, users:', users);
            logUserData();

        }
    }, [users]);

    const logUserData = () => {
        // console.log({ users: users });
        if (users?.length > 0) {
        }
    };

    useEffect(() => {
        const filtered_result = products.filter((products) => {
            return (
                products.product_name.toLowerCase().match(seacrh.toLowerCase())
            );
        });
        setFilteredProducts(filtered_result);
    }, [seacrh]);
    const exporttoExcelData = () => {
        var wb = XLSX.utils.book_new(), ws = XLSX.utils.json_to_sheet(sheetdata);
        XLSX.utils.book_append_sheet(wb, ws, 'Product Category');
        XLSX.writeFile(wb, "Selzor_Product_Categories.xlsx");
    }

    const getProducts = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetProducts`, { app: 0 }, { withCredentials: true })
                .then((response) => {
                    if (!isMounted.current) return;
                    StopLoading(setisLoading);
                    // console.log(response.data);
                    if (response.data.success === 1) {
                        StopLoading(setisLoading)
                        setProducts(response.data.data);
                        setFilteredProducts(response.data.data);
                        setSheetdata(response.data.data);
                        if (location.pathname === '/view-products') { showToast(response.data.message, 'success'); }
                    }
                    else {
                        StopLoading(setisLoading)
                        if (location.pathname === '/view-products') { showToast(response.data.message, 'error'); }
                    }
                })
                .catch((err) => {
                    if (!isMounted.current) return;
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            if (!isMounted.current) return;
            StopLoading(setisLoading);
            if (location.pathname === '/view-products') {
                showToast("Failed to Get Products, please try again laters ", 'error');
            }

        }
    };

    const deleteProduct = async (product_unique_id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this product?");
        if (!confirmDelete) {
            return;  // Exit the function if the user cancels the deletion
        }
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/DeleteProduct`, { product_id: product_unique_id, app: 0 }, { withCredentials: true })
                .then((response) => {
                    if (!isMounted.current) return;
                    StopLoading(setisLoading);
                    // console.log(response.data);
                    if (response.data.success === 1) {

                        StopLoading(setisLoading)
                        showToast(response.data.message, 'success');
                        setProducts(response.data.data);
                        setFilteredProducts(response.data.data);
                        setSheetdata(response.data.data);
                    }
                    else {
                        StopLoading(setisLoading)
                        showToast(response.data.message, 'error');
                    }
                })
                .catch((err) => {
                    if (!isMounted.current) return;
                    const res_status = err.response.data.success;
                    const res_message = err.response.data.message;
                    if (res_status !== "" && res_message !== "") { }
                    else if (err.status === 401) {
                        // logout();
                    }
                    else {
                        showToast(err.data.message, 'error');
                    }
                });
        } catch (err) {
            if (!isMounted.current) return;
            StopLoading(setisLoading);
            showToast("Failed to Delete Product, please try again later ", 'error');
        }
    };


    // 

    const handleToggleStatus = async (rowId, check) => {

        if (rowId !== "") {
            StartLoading(setisLoading);
            try {
                await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/ProductActiveToggle`, { product_id: rowId, check, app: 0 }, { withCredentials: true })
                    .then((response) => {
                        if (!isMounted.current) return;
                        StopLoading(setisLoading);
                        // console.log(response.data);
                        if (response.data.success === 1) {

                            StopLoading(setisLoading)
                            showToast(response.data.message, 'success');
                            getProducts();
                            setProducts([]);
                            setFilteredProducts([]);
                            setSheetdata(response.data.data);
                        }
                        else {
                            StopLoading(setisLoading)
                            showToast(response.data.message, 'error');
                        }
                    })
                    .catch((err) => {
                        if (!isMounted.current) return;
                        const res_status = err.response.data.success;
                        const res_message = err.response.data.message;
                        if (res_status !== "" && res_message !== "") { }
                        else if (err.status === 401) {
                            // logout();
                        }
                        else {
                            showToast(err.data.message, 'error');
                        }
                    });
            } catch (err) {
                if (!isMounted.current) return;
                StopLoading(setisLoading);
                showToast("Failed to Delete Product, please try again later ", 'error');
            }
        }

        // Toggle logic here (maybe API call or state update)
        // const updatedStatus = row.is_visible === 1 ? 0 : 1;

        // console.log("Toggling status for row ID:", row.id);
        // console.log("New status:", updatedStatus);

        // Example: If you're calling an API
        // axios.post('/api/toggle-status', { id: row.id, is_visible: updatedStatus })

        // Or update local state if needed
    };



    return { filteredProducts, users,userPlan,Remainuser,subUser, setSearch, deleteProduct, exporttoExcelData, handleToggleStatus }
}

export default MidViewProducts